import { useRouteParams } from '#imports'

import { CMS_PAGE_SECTION_NAMES } from '@backmarket/http-api/src/api-specs-content/models/cms-sections'
import type { PlpPageNameExperiment } from '@backmarket/nuxt-module-experiments/config'
import { useExperimentValue } from '@backmarket/nuxt-module-experiments/useExperimentValue'

import { useFetchFormattedCMSSections } from '~/scopes/cms/composables/useFetchFormattedCMSSections'

export const PLP_AB_TEST_EXPERIMENT_BY_SLUG: Record<
  string,
  PlpPageNameExperiment
> = {
  iphone: 'experiment.iphonePlpPageName',
  'iphone-reconditionne': 'experiment.iphonePlpPageName',
  samsung: 'experiment.samsungPlpPageName',
  'google-pixel': 'experiment.googlePixelPlpPageName',
  'smartphone-google-reconditionne': 'experiment.googlePixelPlpPageName',
  'android-smartphones': 'experiment.androidSmartphonesPlpPageName',
  'smartphones-android': 'experiment.androidSmartphonesPlpPageName',
  'apple-macbook': 'experiment.macbookPlpPageName',
  'macbook-reconditionne': 'experiment.macbookPlpPageName',
  'windows-laptops': 'experiment.windowsLaptopsPlpPageName',
  'ordinateur-portable-bureautique-reconditionne':
    'experiment.windowsLaptopsPlpPageName',
  'apple-ipad': 'experiment.ipadPlpPageName',
  ipad: 'experiment.ipadPlpPageName',
  'samsung-galaxy-tab': 'experiment.samsungGalaxyTabPlpPageName',
  'tablettes-samsung-galaxy-tab-reconditionnee':
    'experiment.samsungGalaxyTabPlpPageName',
  'apple-watch': 'experiment.appleWatchPlpPageName',
  'apple-watch-reconditionnee': 'experiment.appleWatchPlpPageName',
}

export function useFetchProductListCMSSections() {
  const { slugV2: routeSlug, uuid } = useRouteParams()

  const slugExperimentName = PLP_AB_TEST_EXPERIMENT_BY_SLUG[routeSlug]
  const slug = slugExperimentName
    ? useExperimentValue(slugExperimentName, { defaultValue: routeSlug })
    : routeSlug

  return useFetchFormattedCMSSections({
    pageName: CMS_PAGE_SECTION_NAMES.LANDING_PAGE,
    slug,
    publicId: uuid,
  })
}
